export default __webpack_public_path__ + "static/media/Rajesh Sain.45b9e129.JPG";